export const ViewerType = 'wixui.Menu';

export const TranslationKeys = {
  label: 'Menu', // TODO: replace with translation key
};

export const MenuOrientation = {
  Horizontal: 'horizontal',
  Vertical: 'vertical',
} as const;

export const ComponentMetaData = {
  displayName: 'Menu',
  componentType: ViewerType,
  nickName: 'menu',
  skinName: 'wixui.skins.Menu',
};
